import ErrorMessage from "./ErrorMessage";
import PropTypes from "prop-types";
import React from "react";
import {Field} from "formik";
import FormField from "./FormField";

const races = [
  'African American',
  'Asian',
  'Hispanic or Latino',
  'Native American',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Other'
];

const RaceField = ({name, label, options = races, ...props}) => {
  return (<FormField label={label} type="checkbox" name={name} options={options} {...props}/>);
}

RaceField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default RaceField;
